// extracted by mini-css-extract-plugin
export default {"search":"index_search__T7E6v"};